export default __webpack_public_path__ + "static/media/BlogPic4.1a5f1f36.jpg";